angular.
module("dx.webapp.api").
factory("dxApiV1Students", function apiV1StudentsService(
	$http,
	$httpParamSerializer
) {
	"use strict";

	// params: {organizationID: number, studentIds: [number], emails[string]}
	function getStudents(params) {
		return $http.get("/api/v1/students", {params: params});
	}

	function importStudents(studentData) {
		return $http.put("/api/v1/students", studentData);
	}

	function createStudent(studentData) {
		return $http.post("/api/v1/students", studentData);
	}

	function getDeletableStudents(params) {
		return $http.get("/api/v1/students/deletable", {params: params});
	}

	function deleteStudents(studentIDs) {
		var queryParams = {
			studentIds: studentIDs.join(","),
		};
		return $http.delete("/api/v1/students?" + $httpParamSerializer(queryParams));
	}

	function examList(studentID) {
		return $http.get("/api/v1/students/" + studentID + "/exam/list").
			then(function success(response) {
				return response.data;
			});
	}

	function bulkChangeStudentCodes(execute, studentInputData) {
		return $http.post("/api/v1/mastertools/bulkchangestudentcode?execute=" + execute, studentInputData);
	}

	return {
		get: getStudents,
		import: importStudents,
		create: createStudent,
		getDeletable: getDeletableStudents,
		delete: deleteStudents,
		examList: examList,
		bulkChangeStudentCodes: bulkChangeStudentCodes,
	};
});
